module.exports = __webpack_public_path__ + "img/logout.0018a020.svg";